import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PyramidtextComponent } from './pyramidtext.component';

const routes: Routes = [{ path: '', component: PyramidtextComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PyramidtextRoutingModule { }
